import styled from "styled-components";


export const AddMournerContainer = styled.div`
  padding: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const CloseButton = styled.div`
  cursor: pointer;
  position: absolute;
  top: 15px;
  right: 15px;
`